import ACTIONTYPE_ADDRESS from './Constants';
import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { apiUrls } from '../../constants/apiUrl';
import { getFormatedDate, getURLEndPoint } from '../../components/Web/AddressSearch/constant';
import { isFCCInternalPage } from '../../components/common/Helpers';

export const resetErrorMessage = () => ({
  type: ACTIONTYPE_ADDRESS.RESET_ERROR_MESSAGE,
});

export const showErrorBanner = (data) => ({
  type: ACTIONTYPE_ADDRESS.SHOW_ERROR_MESSAGE,
  data,
});

export const updateParsedAddress = (data) => ({
  type: ACTIONTYPE_ADDRESS.UPDATE_PARSED_ADDRESS,
  data,
});
export const continueButtonStatus = (data) => ({
  type: ACTIONTYPE_ADDRESS.UPDATE_CONTINUE_BUTTON_STATUS,
  data,
});
export const updateUserTypedAddress = (data) => ({
  type: ACTIONTYPE_ADDRESS.UPDATE_USER_TYPED_ADDRESS,
  data,
});
export const storeUserSelectedAddress = (data) => ({
  type: ACTIONTYPE_ADDRESS.STORE_USER_SELECTED_ADDRESS,
  data,
});

export const getFCCDetails = (data) => ({
  type: ACTIONTYPE_ADDRESS.GET_FCC_DETAILS,
  data,
});

export const getFCCProspectPlans = (data) => ({
  type: ACTIONTYPE_ADDRESS.GET_FCC_PROSPECT_PLANS,
  data,
});

export const makeRetriveZipcodeCall = (data) => ({
  type: ACTIONTYPE_ADDRESS.MAKE_RETRIEVE_ZIPCODE_CALL,
  data,
});

export const makeNewBrowsingCall = (data) => ({
  type: ACTIONTYPE_ADDRESS.NEW_BROWSING_API_CALL,
  data,
});

export const updateTaxDetails = (data) => ({
  type: ACTIONTYPE_ADDRESS.UPDATE_TAX_DETAILS,
  data,
});

export const getFccProspectPlansFromAPI = (data) => {
  // const flowName = getURLEndPoint();
  const apiUrl = `${getSecureBaseUrl()}${apiUrls().fccProspectPlans}`;
  return HttpService.post(apiUrl, data);
};

export const getFCCLabelDetailsFromAPI = (data) => {
  let queryString = 'vzw/fcc/wireless/getPlanDetails.all.json'
  if(isFCCInternalPage()){
    const selectedFCCDate = new Date(data?.data);
    const {date,month,year} = getFormatedDate(selectedFCCDate)
    queryString = `vzw/fcc/wireless/getPlanDetails.all.${year}-${month}-${date}.json`
  }
  const flowName = getURLEndPoint();
  const apiUrl = `${getSecureBaseUrl()}${apiUrls().broadBandFactURL}`;
  const payload = {
    queryString,
  };
  if (flowName !== '' && flowName !== null && flowName !== undefined) {
    payload.category = flowName;
  }
  return HttpService.post(apiUrl, payload);
};
export const makeNewBrowsingCallFromAPI = (data) => {
  const apiUrl = `${getSecureBaseUrl()}${apiUrls().newBrowsingURL}`;
  return HttpService.post(apiUrl, data);
};

export const makeRetriveZipcodeCallFromAPI = (data) => {
  const apiUrl = `${getSecureBaseUrl()}${apiUrls().zipMarketDetailsUrl}`;
  return HttpService.post(apiUrl, data);
};

export const setSelectedDate = (data) => ({
  type: 'SET_SELECTED_DATE',
  data,
});

export const setPlanIdFilter = (data) => ({
  type: 'SET_PLAN_FILTER',
  data,
});
